export default __webpack_public_path__ + "static/media/refer-left.c9659911.svg";